function TextFromDeviceIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3696 3.69902L14.3627 3.133L14.3629 3.1329C14.8001 2.88349 15.2793 3.03437 15.5607 3.18547C15.5758 3.1935 15.5917 3.20224 15.6075 3.21125L15.6084 3.21176L22.9478 7.36713L22.9487 7.36762C23.7648 7.82537 24.3216 8.76423 24.3216 9.70351V9.70464L24.275 27.154V27.1546C24.2749 27.4728 24.1817 27.9933 23.7221 28.2518C23.7217 28.252 23.7212 28.2523 23.7207 28.2526L22.7376 28.8129L22.7349 28.8144L22.7343 28.8134C22.7297 28.816 22.7251 28.8187 22.7205 28.8212C22.3352 29.036 21.8798 28.9622 21.4832 28.7374L19.5687 27.6534C19.4325 27.792 19.2753 27.9123 19.1003 28.0093M19.1003 28.0093C18.8099 28.1702 18.4936 28.2532 18.1635 28.2532C17.94 28.2532 17.7344 28.2195 17.5273 28.1455L17.515 28.1411L17.4468 28.1119L16.9875 27.8561L16.9608 27.835C16.8489 27.7467 16.7483 27.6473 16.6603 27.5387L10.4343 24.0983C9.77235 23.8616 9.24733 23.2389 9.24733 22.4336V12.1899L7.5 11.2131V10.0627C7.5 9.65456 7.72572 9.16917 8.02341 8.82104C8.31674 8.47801 8.81595 8.11919 9.40938 8.27776L9.45946 8.29115L12.8026 10.1368L12.8171 4.79676C12.8183 4.34385 12.986 3.91735 13.3696 3.69902"
        fill="#373737"
      />
      <path
        d="M15.3614 3.56C15.3736 3.56646 15.3862 3.57342 15.3984 3.58038L22.7411 7.7376C23.4253 8.121 23.8981 8.91959 23.8981 9.70407L23.8515 27.1546C23.8515 27.4271 23.7682 27.7407 23.514 27.8832L22.5255 28.4466C22.7771 28.3008 22.8587 27.9916 22.8587 27.7202L22.9058 10.2702C22.9058 9.55581 22.4072 8.68176 21.7489 8.30442L14.4056 4.14601C14.3666 4.12364 14.3286 4.10475 14.2906 4.08736L14.2868 4.08562L14.283 4.08388C14.246 4.06698 14.209 4.05256 14.173 4.04063C14.1705 4.04014 14.1684 4.03964 14.1659 4.03865C14.1315 4.02721 14.0975 4.01827 14.0641 4.01081C14.0621 4.01053 14.0601 4.0101 14.0582 4.00968L14.0539 4.00882C14.021 4.00187 13.989 3.99739 13.9576 3.99441L13.9523 3.99391L13.947 3.99342C13.9166 3.99143 13.8877 3.99093 13.8588 3.99193L13.8497 3.99242L13.8406 3.99292C13.8112 3.99491 13.7818 3.99839 13.7539 4.00385C13.7512 4.00439 13.7486 4.00521 13.7461 4.00601L13.7461 4.00601L13.7461 4.00601C13.7439 4.0067 13.7418 4.00737 13.7397 4.00783C13.7154 4.0133 13.6916 4.01976 13.6688 4.02771C13.6379 4.03865 13.6085 4.05207 13.5801 4.06797L14.5734 3.50185C14.6012 3.48594 14.6311 3.47252 14.662 3.46159L14.664 3.46055C14.6652 3.45995 14.6661 3.45942 14.6671 3.4591C14.6884 3.45214 14.7102 3.44667 14.7325 3.4417C14.735 3.44121 14.7374 3.44046 14.7398 3.43972C14.7422 3.43897 14.7447 3.43822 14.7472 3.43773L14.7479 3.43748L14.7487 3.43723C14.7705 3.43325 14.7928 3.42978 14.8156 3.42779L14.825 3.42729L14.8344 3.42679C14.8404 3.4263 14.8465 3.4258 14.8526 3.4258C14.8563 3.4258 14.8601 3.42556 14.8639 3.42531L14.8639 3.42531L14.8639 3.42531C14.8678 3.42506 14.8718 3.4248 14.8759 3.4248C14.8936 3.4248 14.9119 3.4253 14.9301 3.42679C14.9333 3.42679 14.936 3.42718 14.9391 3.42762L14.9403 3.42779C14.9438 3.42779 14.9474 3.42828 14.9509 3.42878L14.9608 3.42962C14.9679 3.43019 14.9749 3.43074 14.9818 3.43176C14.9985 3.43425 15.0153 3.43673 15.0325 3.44021C15.0358 3.44053 15.0388 3.44126 15.0419 3.44201L15.0472 3.4432L15.0523 3.44419L15.0573 3.44518C15.0649 3.44667 15.0725 3.44817 15.0801 3.45015C15.0958 3.45413 15.1116 3.45811 15.1278 3.46308C15.1379 3.46606 15.1486 3.46954 15.1587 3.47302L15.1625 3.47426L15.1663 3.4755L15.1699 3.47656C15.1714 3.477 15.1729 3.47741 15.1744 3.47799C15.1896 3.48345 15.2053 3.48942 15.221 3.49538C15.2362 3.50134 15.2514 3.50781 15.2671 3.51477C15.2697 3.51576 15.2727 3.51725 15.2758 3.51874L15.2758 3.51874L15.2796 3.52048L15.2834 3.52222C15.2935 3.5267 15.3036 3.53117 15.3138 3.53614C15.3295 3.5436 15.3457 3.55155 15.3614 3.56Z"
        fill="url(#paint0_linear_9870_6502)"
      />
      <path
        d="M21.7463 8.30419C22.3873 8.66753 22.9052 9.54728 22.9032 10.27L22.8561 27.7195C22.8541 28.4422 22.3326 28.7325 21.6915 28.3691L14.3493 24.2119C13.7093 23.8496 13.1913 22.9708 13.1934 22.2481L13.2405 4.79858C13.2425 4.07589 13.764 3.78463 14.4041 4.14697L21.7463 8.30419Z"
        fill="#575757"
      />
      <path
        d="M22.2583 27.6029C22.2528 27.6894 22.2294 27.8255 22.1484 27.8255C22.118 27.8255 22.0328 27.8171 21.895 27.7391L14.6673 23.6469C14.197 23.38 13.7875 22.6847 13.7891 22.1563L13.8352 4.97671C13.8352 4.92849 13.8423 4.69141 13.9497 4.69141C13.9801 4.69141 14.0653 4.69836 14.2001 4.77491L14.2031 4.7764C14.2001 4.80473 14.2001 4.83058 14.2001 4.84151L14.1539 22.0196C14.1524 22.5475 14.5634 23.2448 15.0322 23.5103L22.2583 27.6029Z"
        fill="#323232"
      />
      <path
        d="M21.4296 8.86994L18.8911 7.43201L18.8263 7.39523C18.7467 7.34999 18.6525 7.38827 18.6119 7.46779C18.6104 7.47078 18.6089 7.47326 18.6074 7.47475C18.5177 7.64076 18.3008 7.67506 18.0489 7.53589C17.7712 7.38379 17.5381 7.07165 17.4656 6.78238C17.4397 6.67303 17.3744 6.57362 17.2745 6.51696L14.2035 4.77832C14.2004 4.80665 14.2004 4.8325 14.2004 4.84343L14.1543 22.0216C14.1528 22.5494 14.5638 23.2468 15.0325 23.5122L22.2587 27.6043C22.2617 27.576 22.2617 27.5531 22.2617 27.5417L22.3078 10.362C22.3114 9.83369 21.8999 9.13536 21.4296 8.86994Z"
        fill="white"
      />
      <path
        d="M18.2101 7.07476C18.2101 7.17019 18.1311 7.19355 18.0338 7.12645C17.9365 7.05935 17.8574 6.92764 17.8574 6.8322C17.8574 6.73677 17.9365 6.71341 18.0338 6.78051C18.1311 6.84761 18.2101 6.97883 18.2101 7.07476Z"
        fill="#323232"
      />
      <path d="M21.7458 10.6586L14.5703 6.62012V7.5123L21.7458 11.5507V10.6586Z" fill="#B3BECC" />
      <path d="M21.7458 12.3231L14.5703 8.28516V9.17684L21.7458 13.2153V12.3231Z" fill="#B3BECC" />
      <path d="M14.5996 9.94824V10.8404L21.7751 14.8784V13.9867L14.5996 9.94824Z" fill="#B3BECC" />
      <path d="M14.5996 12.5025L21.7751 16.541V15.6488L14.5996 11.6104V12.5025Z" fill="#B3BECC" />
      <path
        d="M14.5996 13.0947V13.7811V13.9864V14.384V14.6733V15.2762L21.7751 19.3142V18.7113V18.4225V18.0248V17.8196V17.1332L14.5996 13.0947Z"
        fill="#B3BECC"
      />
      <path
        d="M17.8982 17.6924L14.5996 15.8359V16.5223V16.7281V17.1253V17.4145V18.0174L17.8982 19.8739V17.6924Z"
        fill="#B3BECC"
      />
      <path
        d="M18.4766 17.9854V20.1669L21.7747 22.0228V21.4204V21.1311V20.7335V20.5282V19.8418L18.4766 17.9854Z"
        fill="#B3BECC"
      />
      <path
        d="M17.6925 27.6249C17.5511 27.5752 17.4189 27.5011 17.3008 27.4092L17.6925 27.6249Z"
        fill="url(#paint1_linear_9870_6502)"
      />
      <path
        d="M21.4037 22.7392L21.3094 25.2915L19.5078 24.2979L19.6021 23.8049C19.6021 23.4858 19.6877 23.1761 19.8423 22.9067C19.9969 22.6373 20.2219 22.4057 20.5006 22.2402C20.6602 22.1453 20.8381 22.1343 20.9942 22.1855L20.9972 22.1865C21.2248 22.2606 21.4037 22.4698 21.4037 22.7392Z"
        fill="url(#paint2_linear_9870_6502)"
      />
      <path
        d="M16.5304 12.6791C16.2369 12.54 15.8977 12.7059 15.6517 12.8685C14.9683 13.3189 15.0241 14.168 14.9488 14.8914L7.92383 10.9644V10.0627C7.92383 9.50996 8.5896 8.49766 9.29973 8.68742L16.5304 12.6791Z"
        fill="url(#paint3_linear_9870_6502)"
      />
      <path
        d="M17.2999 27.408L10.6079 23.71C10.0819 23.5355 9.67188 23.0534 9.67188 22.4341V11.9287L14.9489 14.8921L15.0427 13.9914C15.0427 13.5406 15.2708 13.1206 15.6518 12.8691L15.773 12.7891C15.9818 12.6524 16.2235 12.6514 16.4201 12.7444L16.4667 12.7702C16.5605 12.8239 16.6406 12.8999 16.6989 12.9939C16.7556 13.0868 16.7896 13.1976 16.7896 13.3199V26.3622C16.7901 26.7991 16.9948 27.1674 17.2999 27.408Z"
        fill="url(#paint4_linear_9870_6502)"
      />
      <path
        d="M21.1321 22.1215C20.9766 22.0708 20.6593 22.1449 20.4997 22.2398C20.221 22.4053 19.996 22.6369 19.8414 22.9063C19.6868 23.1757 19.6012 23.4849 19.6012 23.8045V26.2449C19.6012 26.7778 19.3083 27.2698 18.8339 27.5323C18.616 27.653 18.3864 27.7077 18.1624 27.7077C18.0018 27.7077 17.8442 27.6799 17.6957 27.6267L17.6926 27.6247L17.3009 27.409L17.2999 27.408L17.2989 27.407C16.9938 27.1664 16.7891 26.7981 16.7891 26.3612V19.7422L21.1321 22.1215Z"
        fill="url(#paint5_linear_9870_6502)"
      />
      <path
        d="M21.0762 22.0866L21.0326 22.0712C20.8314 22.0055 20.6201 22.0289 20.4376 22.1373C20.1462 22.3102 19.9035 22.5558 19.7363 22.8475C19.569 23.1393 19.4803 23.4698 19.4803 23.8043V26.2448C19.4803 26.7334 19.2102 27.1867 18.7754 27.4277C18.5838 27.5341 18.3781 27.5878 18.1642 27.5878C18.0137 27.5878 17.887 27.5669 17.7588 27.5212L17.3696 27.3079C17.0792 27.0753 16.913 26.7314 16.913 26.3616V13.3193C16.913 13.1806 16.8755 13.0464 16.8051 12.9311C16.7382 12.8228 16.6434 12.7313 16.5289 12.6657L16.4746 12.6359C16.2248 12.5176 15.9375 12.538 15.7064 12.6891L15.5852 12.7691C15.1697 13.043 14.9219 13.4997 14.9219 13.9908V14.8919H15.1661V13.9908C15.1661 13.5793 15.3739 13.197 15.7216 12.9679L15.8427 12.8884C16.0003 12.785 16.1964 12.7711 16.3672 12.8511L16.4067 12.8735C16.4848 12.9182 16.5502 12.9813 16.5958 13.0554C16.6444 13.1344 16.6687 13.2234 16.6687 13.3198V26.3621C16.6687 26.8079 16.8714 27.223 17.2242 27.5013L17.6347 27.7299L17.6706 27.7453C17.8293 27.802 17.9864 27.8283 18.1642 27.8283C18.4212 27.8283 18.667 27.7642 18.8955 27.6375C19.4069 27.3542 19.7246 26.8213 19.7246 26.2463V23.8058C19.7246 23.5126 19.8021 23.2223 19.9491 22.9668C20.0961 22.7113 20.3084 22.4956 20.5643 22.344C20.6849 22.2725 20.8238 22.257 20.9525 22.2993L20.989 22.3122C21.1674 22.3833 21.2824 22.5513 21.2824 22.7407V25.293H21.5267V22.7407C21.5257 22.4514 21.3509 22.1964 21.0762 22.0866Z"
        fill="#575757"
      />
      <path
        d="M14.383 15.7676L11.7847 14.3132C11.6808 14.2551 11.5957 14.1243 11.5957 14.0225C11.5957 13.9206 11.6808 13.8848 11.7847 13.9429L14.383 15.3973C14.4869 15.4554 14.572 15.5861 14.572 15.688C14.5715 15.7899 14.4869 15.8257 14.383 15.7676Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 17.0255L11.1597 14.8718C11.0558 14.8137 10.9707 14.6829 10.9707 14.581C10.9707 14.4792 11.0558 14.4434 11.1597 14.5015L15.0077 16.6552C15.1116 16.7133 15.1967 16.8441 15.1967 16.946C15.1967 17.0478 15.1116 17.0836 15.0077 17.0255Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 17.9347L11.1597 15.781C11.0558 15.7228 10.9707 15.5921 10.9707 15.4902C10.9707 15.3883 11.0558 15.3525 11.1597 15.4107L15.0077 17.5644C15.1116 17.6225 15.1967 17.7532 15.1967 17.8551C15.1967 17.957 15.1116 17.9928 15.0077 17.9347Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 18.8438L11.1597 16.6902C11.0558 16.632 10.9707 16.5013 10.9707 16.3994C10.9707 16.2975 11.0558 16.2617 11.1597 16.3199L15.0077 18.4735C15.1116 18.5317 15.1967 18.6624 15.1967 18.7643C15.1967 18.8662 15.1116 18.902 15.0077 18.8438Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 19.752L11.1597 17.5984C11.0558 17.5402 10.9707 17.4095 10.9707 17.3076C10.9707 17.2057 11.0558 17.1699 11.1597 17.2281L15.0077 19.3817C15.1116 19.4399 15.1967 19.5706 15.1967 19.6725C15.1967 19.7744 15.1116 19.8102 15.0077 19.752Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 20.6602L11.1597 18.5066C11.0558 18.4484 10.9707 18.3177 10.9707 18.2158C10.9707 18.1139 11.0558 18.0781 11.1597 18.1363L15.0077 20.29C15.1116 20.3481 15.1967 20.4788 15.1967 20.5807C15.1967 20.6826 15.1116 20.7184 15.0077 20.6602Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 21.5684L11.1597 19.4148C11.0558 19.3566 10.9707 19.2259 10.9707 19.124C10.9707 19.0221 11.0558 18.9863 11.1597 19.0445L15.0077 21.1982C15.1116 21.2563 15.1967 21.387 15.1967 21.4889C15.1967 21.5908 15.1116 21.6266 15.0077 21.5684Z"
        fill="#ED3535"
      />
      <path
        d="M14.383 22.9189L11.7847 21.4646C11.6808 21.4064 11.5957 21.2757 11.5957 21.1738C11.5957 21.0719 11.6808 21.0361 11.7847 21.0943L14.383 22.5486C14.4869 22.6068 14.572 22.7375 14.572 22.8394C14.5715 22.9413 14.4869 22.9771 14.383 22.9189Z"
        fill="#ED3535"
      />
      <path
        d="M15.0077 24.1768L11.1597 22.0232C11.0558 21.965 10.9707 21.8343 10.9707 21.7324C10.9707 21.6305 11.0558 21.5947 11.1597 21.6529L15.0077 23.8066C15.1116 23.8647 15.1967 23.9954 15.1967 24.0973C15.1967 24.1992 15.1116 24.235 15.0077 24.1768Z"
        fill="#ED3535"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9870_6502"
          x1="18.7391"
          y1="3.4248"
          x2="18.7391"
          y2="28.4466"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0950197" stopColor="white" />
          <stop offset="0.28055" stopColor="#CBD1D8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9870_6502"
          x1="17.3006"
          y1="27.5172"
          x2="17.6923"
          y2="27.5172"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0368" stopColor="#A5A7B3" />
          <stop offset="0.1212" stopColor="#B3B4BE" />
          <stop offset="0.3097" stopColor="#C3C3CA" />
          <stop offset="1" stopColor="#EEF2F7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9870_6502"
          x1="20.4557"
          y1="22.1553"
          x2="18.928"
          y2="25.8121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBD1D8" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9870_6502"
          x1="11.6127"
          y1="9.80562"
          x2="9.38662"
          y2="14.3638"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBD1D8" />
          <stop offset="0.38064" stopColor="#E5E9ED" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9870_6502"
          x1="13.4859"
          y1="11.9287"
          x2="9.06933"
          y2="25.1767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBD1D8" />
          <stop offset="0.233998" stopColor="#E5E9ED" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_9870_6502"
          x1="18.9606"
          y1="19.7422"
          x2="15.535"
          y2="25.9185"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0950197" stopColor="white" />
          <stop offset="0.515691" stopColor="#CBD1D8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default TextFromDeviceIcon;
